document.addEventListener("DOMContentLoaded", function () {
  const isLargeScreen = window.innerWidth > 1200;
  let scrollOffset = isLargeScreen ? 110 : 80;
  let activeMin = isLargeScreen ? 110 : 80;
  let activeMax = isLargeScreen ? 140 : 100;

  // Adjust sidebar TOC position if WP admin bar exists
  if (document.getElementById("wpadminbar")) {
    const sidebarToc = document.querySelector(".sidebar-toc-container");
    let sidebarTocTop = isLargeScreen ? 120 : 80;
    if (sidebarToc) {
      sidebarToc.style.top = (sidebarTocTop += 20) + "px";
      scrollOffset += 20;
      activeMin += 20;
      activeMax += 20;
    }
  }

  // Generate ID for headings
  const generateSectionID = (headingText) => {
    return headingText
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
  };

  const h2Elements = document.querySelectorAll("#toc-target-content h2");
  const mainArticle = document.querySelector("#toc-target-content");
  const mainArticleVirtual = document.createElement("div");
  mainArticleVirtual.id = "toc-target-content";

  const contentStructure = new Map(); // Prevents duplicate TOC entries

  // Ensure content starts with an H2 wrapped in a section
  if (
    mainArticle &&
    mainArticle.firstElementChild &&
    mainArticle.firstElementChild.tagName !== "H2"
  ) {
    let elementsUntilH2 = [];
    let child = mainArticle.firstElementChild;

    while (child && child.tagName !== "H2") {
      elementsUntilH2.push(child);
      child = child.nextElementSibling;
    }

    const section = document.createElement("section");
    elementsUntilH2.forEach((element) => section.appendChild(element));

    if (mainArticle.firstElementChild) {
      mainArticle.insertBefore(section, mainArticle.firstElementChild);
    } else {
      mainArticle.appendChild(section);
    }

    mainArticleVirtual.append(section);
  }

  // Process each H2 element
  h2Elements.forEach((h2) => {
    const id = generateSectionID(h2.textContent);

    // Prevent duplicate IDs
    if (contentStructure.has(id)) return;

    const h2Section = document.createElement("section");
    h2Section.id = id;
    const contentStructureItem = {
      key: id,
      label: h2.textContent,
      children: [],
    };

    let nextElement = h2.nextElementSibling;
    h2Section.append(h2.cloneNode(true));

    while (nextElement && nextElement.tagName !== "H2") {
      h2Section.append(nextElement.cloneNode(true));
      nextElement = nextElement.nextElementSibling;
    }

    mainArticleVirtual.append(h2Section);
    contentStructure.set(id, contentStructureItem);
  });

  // Replace original article with the new structured version
  if (mainArticle && mainArticle.parentNode) {
    mainArticle.parentNode.replaceChild(mainArticleVirtual, mainArticle);
  }

  // Generate Sidebar TOC
  const jumpToNav = document.querySelector("#jumpToNav ul");
  if (jumpToNav) {
    contentStructure.forEach((item) => {
      jumpToNav.append(
        generateListItemLink(item.key, item.label, item.children)
      );
    });
    // Smooth scroll to the section with dynamic offset
    document
      .querySelector("#jumpToNav")
      .addEventListener("click", function (event) {
        const target = event.target.closest("a");
        if (!target) return;
        event.preventDefault();

        const targetId = target.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const elementPosition =
            targetElement.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - scrollOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      });
  }

  // Function to generate a TOC list item
  function generateListItemLink(key, label, children) {
    const listItem = document.createElement("li");
    const link = document.createElement("a");
    link.href = "#" + key;
    link.textContent = label;

    if (children.length > 0) listItem.classList.add("has-children");

    listItem.appendChild(link);

    if (children.length > 0) {
      const childList = document.createElement("ul");
      children.forEach((subItem) => {
        childList.append(generateListItemLink(subItem.key, subItem.label, []));
      });
      listItem.append(childList);
    }

    return listItem;
  }

  // Observe sections when they are within the defined range
  function checkActiveSection() {
    const sections = document.querySelectorAll("#toc-target-content section");
    let activeSectionId = null;

    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      if (rect.top >= activeMin && rect.top <= activeMax) {
        activeSectionId = section.id;
      }
    });

    if (activeSectionId) {
      document
        .querySelectorAll("#jumpToNav li")
        .forEach((item) => item.classList.remove("active"));
      const activeLink = document.querySelector(
        `#jumpToNav li a[href="#${activeSectionId}"]`
      );
      if (activeLink) activeLink.parentElement.classList.add("active");
    }
  }

  // Listen for scroll events
  window.addEventListener("scroll", checkActiveSection);
});
